export default function AutoScroll() {
  const container = document.querySelector('.o-build__box-gallery')

  if (!container) {
    return
  }

  const scrollDistance = 300
  const intervalTime = 4000
  let scrollDirection = 1
  let scrollInterval

  const startScroll = () => {
    scrollInterval = setInterval(() => {
      const currentScroll = container.scrollLeft
      const maxScroll = container.scrollWidth - container.clientWidth

      let nextScroll

      if (scrollDirection === 1) {
        nextScroll = currentScroll + scrollDistance
      } else {
        nextScroll = currentScroll - scrollDistance
      }

      if (nextScroll >= maxScroll) {
        scrollDirection = -1
        nextScroll = maxScroll
      } else if (nextScroll <= 0) {
        scrollDirection = 1
        nextScroll = 0
      }

      container.scrollTo({
        left: nextScroll,
        behavior: 'smooth'
      })
    }, intervalTime)
  }

  const stopScroll = () => {
    clearInterval(scrollInterval)
  }

  container.addEventListener('mouseenter', stopScroll)
  container.addEventListener('mouseleave', startScroll)
  container.addEventListener('touchstart', stopScroll)
  container.addEventListener('touchend', startScroll)

  window.addEventListener('resize', () => {
    if (window.innerWidth < 1024) {
      startScroll()
    } else {
      stopScroll()
    }
  })
}
